import script from "./ActionBarLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionBarLayout.vue?vue&type=script&lang=ts&setup=true"

import "./ActionBarLayout.vue?vue&type=style&index=0&id=2a2eb64c&lang=scss&scoped=true"

import exportComponent from "/Users/mac/work/aem/weixin-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2eb64c"]])

export default __exports__